<template>
  <div class="hero container">
    <img src="../../assets/fylo-two-columns-landing/illustration-1.svg" alt="" class="hero__img">
    <div class="hero__content">
      <div class="hero__title">All your files in one secure location, accessible anywhere.</div>
      <p class="hero__text">
        Fylo stores your most important files in one secure location. Access
        them wherever you need, share and collaborate with friends, family,
        and co-workers.
      </p>
    </div>
    <form class="hero__form form" @submit="onSubmit">
      <div class="form__control">
        <input
          class="form__input input"
          v-model="email"
          @change="handleChange"
          placeholder="Enter your email"
          :style="showError && 'border: 2px solid red;'"
        />
        <span class="form__error" v-if="showError">{{error}}</span>
      </div>
      <button class="form__button button" type="submit">get started</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      error: 'Please check your email',
      showError: false,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.emailIsValid(this.email) && this.email) this.showError = true;
      else this.showError = false;
    },
    handleChange(evt) {
      this.email = evt.target.value;
    },
    emailIsValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
    margin-top: var(--bg-spacer);
    color: var(--very-dark-blue);

    @media (min-width: 90em) {
      display: grid;
      grid-template-areas: "a c" "b c";
      align-items: center;
      text-align: initial;
    }

    &__img {
      margin-bottom: var(--sm-spacer);
      grid-area: c;
      @media (min-width: 90em) {
        margin-bottom: 0;
      }
    }

    &__text {
      max-width: 60ch;
    }

    &__title {
      line-height: 1;
      font-size: var(--fs-h2);
      margin-bottom: calc(var(--sm-spacer) / 1.5);
      font-weight: var(--fw-600);
    }

    &__content {
      margin-bottom: var(--sm-spacer);
      grid-area: a;
      @media (min-width: 90em) {
        margin-bottom: 0;
      }
    }

    .form {
      grid-area: b;

      &__button, &__input {
        font-size: var(--ff-alt);
        border-radius: var(--border-radius);
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
        width: 100%;
      }

      &__control {
        margin-bottom: calc(var(--sm-spacer) / 2);
      }

      &__input {
        border: 2px solid;
        @media (min-width: 90em) {
          margin-bottom: 0;
        }
      }

      &__button {
        font-weight: var(--fw-600);
        background-color: var(--bright-blue);
        color: var(--light-grayish-blue);
        border: 2px solid var(--bright-blue);

        &:hover, &:focus {
          color: var(--bright-blue);
          background-color: var(--light-grayish-blue);
        }
      }

      &__error {
        color: red;
      }

      @media (min-width: 90em) {
        display: grid;
        grid-template-areas: "a b" "c .";
        grid-template-columns: repeat(2, 1fr);
        column-gap: 2rem;

        &__button {
          grid-area: b;
          width: 60%;
          align-self: flex-start;
        }

        &__input {
          margin-bottom: 0;
          align-self: flex-start;
          grid-area: a;
        }

        &__error {
          grid-area: c;
        }
    }
  }
}
</style>
